<template>
  <div class="customer" :class="{'scoll':scollFlag}">
    <span class='imgBox' @click="cust">
      <img src="../assets/imgs/emit.png" alt="">
    </span>
  </div>
</template>

<script>
export default {
  name: 'customer',
  data(){
    return {
      timer:null,
      scollFlag:false
    }
  },
  mounted() {
      //滚动条监听
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy(){
      window.removeEventListener('scroll', this.handleScroll);
  },
  methods:{
    handleScroll() {
      clearTimeout(this.timer); //清除定時器
      this.timer = setTimeout(this.ScrollEnd, 500);
      this.scollFlag = true;
    },
    ScrollEnd(){
      this.scollFlag = false;
    },
    cust(){
      window.location.href = 'https://url.cn/wOipY03P?_type=wpa&qidian=true'
    }
  }
}
</script>
<style scoped lang="less">
.customer{
  position:fixed;
  bottom:5rem;
  right: .5rem;
  z-index: 99999;
  .imgBox{
    width: 2.5rem;
    height: 3.3rem;
    display: inline-block;
    img{
      width: 100%;
    }
  }
}
.scoll{
  position:fixed;
  right: -1rem;
}

</style>
